import { CommentFileModel } from "./CommentFileModel";

/**Модель описывает обновленные данные комментария */
export class OnUpdateCommentModel {
  /**Id */
  Id!: number;
  /**Текст комментария */
  Message!: string;
  /**Файл прикрепленный к комментарию */
  File?: CommentFileModel;

  constructor(obj?: Partial<OnUpdateCommentModel>) {
    Object.assign(this, obj);
  }
}
